<template>
  <div class="flex flex-wrap gap-3">
    <el-upload
      :show-file-list="false"
      :auto-upload="false"
      multiple
      drag
      :on-change="onFileChange"
      v-if="props.showAdd"
      class="overflow-hidden"
    >
      <div
        class="flex flex-col items-center justify-center gap-y-1"
        style="height: 78px; width: 128px"
      >
        <el-icon :size="24" color="#9ca3af"><upload-filled /></el-icon>
        <text class="text-xs text-gray-400">选择/拖动文件</text>
      </div>

      <!-- <el-button
        plain
        icon="plus"
        style="color: var(--el-color-primary)"
        size="large"
        class="!text-xs hover:!text-green-600 hover:!border-green-600 !w-32 !h-20 p-5"
      >
        上传
      </el-button> -->
    </el-upload>
    <template v-for="(item, index) in state.data" :key="item">
      <text
        v-if="props.showText"
        class="hover:underline cursor-pointer text-green-700"
        @click="onPreview(item)"
        >{{ item.origin_filename }}
      </text>
      <div
        v-else
        class="w-32 h-20 relative cursor-pointer rounded-lg overflow-hidden"
      >
        <el-image class="w-full h-full" :src="item.file_url">
          <template #error>
            <div
              class="relative !text-xs !w-32 !h-20 px-2 border border-dashed border-gray-300 text-center rounded-lg flex items-center cursor-pointer text-gray-500 justify-center"
            >
              <li style="white-space: normal; word-break: break-all">
                {{ item.origin_filename }}
              </li>
            </div>
          </template>
        </el-image>
        <div
          class="bg-black flex items-center justify-center gap-x-3 absolute top-0 left-0 w-full h-full rounded-lg opacity-0 hover:opacity-70"
        >
          <el-icon
            @click="onPreview(item)"
            color="#fff"
            :size="22"
            class="hover:scale-110"
          >
            <View />
          </el-icon>
          <el-icon
            v-if="props.showAdd"
            @click="onDelete(index)"
            color="#fff"
            :size="22"
            class="hover:scale-110"
          >
            <Delete />
          </el-icon>
        </div>
      </div>
    </template>
  </div>
  <el-image-viewer
    v-if="state.showPreview"
    :url-list="state.preview_data"
    show-progress
    :initial-index="state.preview_index"
    teleported
    @close="state.showPreview = false"
  />
</template>

<script>
import { onMounted, reactive } from "vue";
import { attachment_upload } from "@/http/attachment";
import base from "@/utils/base";
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    showText: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.data = props.value;
    });

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.data = [...state.data, ...res.data.data];
          emit("change", state.data);
        }
      });
    };

    const onDelete = (index) => {
      state.data.splice(index, 1);
      emit("change", state.data);
    };

    const onPreview = (item) => {
      if (base.Image_Exts.includes(item.file_ext)) {
        state.preview_data = state.data
          .filter((w) => base.Image_Exts.includes(w.file_ext))
          .map((w) => w.file_url);
        state.preview_index = state.preview_data.findIndex(
          (w) => w == item.file_url,
        );
        state.showPreview = true;
      } else {
        window.open(item.file_url);
      }
    };

    return { state, props, onFileChange, onDelete, onPreview };
  },
};
</script>

<style lang="less" scoped></style>
